import axios from '../../network/axios'
import { HOME_LIST, HOME_LIST_REQUEST } from '../types'

const state = {
	isFetching: false,
	item: {}
}

const getters = {
	nextDonation: (state, getters) => {
		var amount = state.item.nextRoundup
		var max = state.item.maxDonation || Number.MAX_SAFE_INTEGER
		var min = state.item.minDonation

		if (!getters.isDonating) {
			return null
		}
		return Math.min(max, Math.max(amount * 100, min)) / 100
	},
	currentMonthlyTotal: (state) => state.item.currentMonthlyTotal,
	nextDonationDate: (state) =>
		new Date(state.item.nextDate).toLocaleDateString(),
	lastDonationDate: (state) =>
		new Date(state.item.lastPayout.created_at).toLocaleDateString(),
	failedPayout: (state) => {
		const { lastPayout } = state.item
		const error = lastPayout ? lastPayout.stripe_error : ''
		if (error) {
			if (error.toLowerCase().includes('refund')) {
				return ''
			}
			return lastPayout.stripe_error
		}
		return ''
	},
	failedTransactions: (state) => state.item.failedPayouts,
	unlinkedAccounts: (state) => state.item.unlinkedAccounts
}

const actions = {
	getHome({ commit }) {
		return new Promise((resolve, reject) => {
			commit(HOME_LIST_REQUEST)
			axios
				.get('/me/home')
				.then(({ data }) => {
					commit(HOME_LIST, data)
					resolve(data)
				})
				.catch((err) => reject(err))
		})
	}
}

const mutations = {
	[HOME_LIST_REQUEST](state) {
		state.isFetching = true
	},
	[HOME_LIST](state, data) {
		state.isFetching = false
		state.item = data
	}
}

export default {
	state,
	getters,
	actions,
	mutations
}
